import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { listSummaries } from '../lib/db.js';
import { StatusBar } from '../components/StatusBar.jsx';
import { BottomNav } from '../components/BottomNav.jsx';

export function Employees() {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState('');
  const [q, setQ] = useState('');

  useEffect(() => {
    listSummaries().then(setRows).catch((e) => { setErr(e.message); setRows([]); });
  }, []);

  const filtered = useMemo(() => {
    if (!rows) return [];
    const t = q.trim().toLowerCase();
    if (!t) return rows;
    return rows.filter((r) =>
      [r.nickname, r.first_name, r.last_name, r.position, r.branch, r.emp_code]
        .filter(Boolean).join(' ').toLowerCase().includes(t)
    );
  }, [rows, q]);

  return (
    <div className="phone">
      <StatusBar />
      <section className="screen">
        <div className="title-row">
          <div>
            <div className="eyebrow">บุคลากร</div>
            <h1 className="page">พนักงาน</h1>
          </div>
          <span className="glyph">○</span>
        </div>

        <input className="search" type="text" placeholder="ค้นหา ชื่อเล่น · ตำแหน่ง · สาขา"
          value={q} onChange={(e) => setQ(e.target.value)} />

        {err && <p className="err" style={{ marginTop: 16 }}>{err}</p>}
        {!rows && <div className="center"><div className="spinner" /></div>}
        {rows && filtered.length === 0 && <p className="muted" style={{ marginTop: 20 }}>ไม่พบพนักงาน</p>}

        <div className="list-grid" style={{ marginTop: 10 }}>
          {filtered.map((r) => (
            <Link className="row" key={r.id} to={`/employees/${r.id}`}>
              <div className="ic">{(r.nickname || r.first_name || '?').slice(0, 1)}</div>
              <div className="main">
                <div className="l1">{r.nickname || `${r.first_name} ${r.last_name}`}</div>
                <div className="l2">{[r.position, r.branch].filter(Boolean).join(' · ') || '—'}</div>
              </div>
              <StatusDot status={r.status} warnings={r.active_warnings} />
            </Link>
          ))}
        </div>
      </section>
      <BottomNav />
    </div>
  );
}

function StatusDot({ status, warnings }) {
  if (warnings > 0) return <span className="pip warn" title="มีใบเตือนมีผล" />;
  if (status === 'active') return <span className="pip ok" title="ทำงานอยู่" />;
  if (status === 'probation') return <span className="pip pend" title="ทดลองงาน" />;
  return <span className="pip" style={{ background: 'var(--t3)' }} title={status} />;
}
